import fetchEstimate from '../Services/fetchEstimate';

export default () => async (dispatch) => {

  dispatch(fetchEstimate())
  
}